module.exports = __webpack_public_path__ + "static/media/playstore-4e.6c769fdc.png";